/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Ocop_Level_PlaceholderInputs */

const vi_shop_ocop_level_placeholder = /** @type {(inputs: Shop_Ocop_Level_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn cấp`)
};

/**

* @param {Shop_Ocop_Level_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_ocop_level_placeholder = /** @type {((inputs?: Shop_Ocop_Level_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Ocop_Level_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_ocop_level_placeholder(inputs)
});